import { gql } from '@apollo/client';
import { EXPORT_INSTITUTION } from '../../fragments';

export const EXPORT_FUNDER_NSC_PROGRESSION_SCHOOLS = gql`
  query ExportFunderNSCProgressionSchools($input: ExportArgs!) {
    allFunderNSCProgressionSchools(input: $input) {
      ...exportInstitution
    }
  }
  ${EXPORT_INSTITUTION}
`;
